import { useCallback } from "react";
import { handleServerErrors } from "../utils/handleServerErrors";

const useServerValidation = ({ setError, setErrors, fieldMapper } = {}) => {
    const applyServerErrors = useCallback((error) => {
        return handleServerErrors(error, { setError, setErrors, fieldMapper });
    }, [setError, setErrors, fieldMapper]);

    return { applyServerErrors };
};

export default useServerValidation;

